import { useContext } from 'react';
import { useTranslation as useReactI18nTranslation } from 'react-i18next';
import { I18nContext } from './i18n-provider';

export const useTranslation = () => {
	const { t, i18n } = useReactI18nTranslation();
	const { language, setLanguage } = useContext(I18nContext);

	return { t, i18n, language, setLanguage };
};
